import { Edit, Save } from "@mui/icons-material";
import {
    Avatar,
    Box,
    Button,
    Card,
    CardContent,
    CircularProgress,
    Container,
    Divider,
    TextField,
    Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
    useGetPointsMutation,
    useGetStudentDetailsMutation,
    useGetUserInfoMutation,
} from "../../apiSlice";
import bronze from "../Dashboard/StudentDashboard/Dashboard/bronze.png";
import gold from "../Dashboard/StudentDashboard/Dashboard/gold.png";
import legendary from "../Dashboard/StudentDashboard/Dashboard/legendary.png";
import platinum from "../Dashboard/StudentDashboard/Dashboard/platinum.png";
import silver from "../Dashboard/StudentDashboard/Dashboard/silver.png";
import SideBar from "../Dashboard/StudentDashboard/Sidebar/SideBar";
import Breadcrumb from "../StudentBreadcrumb/Breadcrumb";
import {
    API_BannerURL,
    API_courseURL,
    API_LoginURL,
    Img_APIURL,
} from "../../config";

const StudentProfile = () => {
    // State for student data
    const [studentData, setStudentData] = useState(null);
    const [studentDetails, setStudentDetails] = useState(null);
    const [earnedPoints, setEarnedPoints] = useState(null);
    const [loading, setLoading] = useState(true);
    const [editMode, setEditMode] = useState(false);

    // Form state for editable fields
    const [formData, setFormData] = useState({
        fathersName: "",
        mothersName: "",
        fathersPhone: "",
        mothersPhone: "",
    });
    const [studentDataAPI] = useGetUserInfoMutation();
    const [studentDetailsAPI] = useGetStudentDetailsMutation();
    const [badgePointsAPI] = useGetPointsMutation();

    const textFieldStyle = {
        margin: 0,
        "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(0, 0, 0, 0.25)",
        },
    };

    useEffect(() => {
        console.log("studentData ======= ", studentData);
    }, [studentData]);

    // Fetch student data from API
    useEffect(() => {
        const fetchStudentData = async () => {
            try {
                // Simulate API call
                const studentData = await studentDataAPI();
                const studentDetails = await studentDetailsAPI();
                const badgePoints = await badgePointsAPI();

                // Loggin total badge points
                console.log("BADGE POINTS --------- ", badgePoints?.data);

                // Setting badge points
                setEarnedPoints(badgePoints?.data);

                if (studentDetails !== null) {
                    const response = studentDetails.data[0];
                    setStudentDetails(response);
                    setFormData({
                        fathersName: response.fatherName,
                        mothersName: response.motherName,
                        fathersPhone: response.father_Phone_Number,
                        mothersPhone: response.mother_Phone_Number,
                    });
                }
                setStudentData(studentData.data[0]);

                setLoading(false);
                console.log("StudentData ------------ ", studentData);
                console.log("StudentDetails ------------ ", studentDetails);
            } catch (error) {
                console.error("Error fetching student data:", error);
                setLoading(false);
            }
        };

        fetchStudentData();
    }, [loading]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSave = () => {
        // Here you would typically send the updated data to your API
        console.log("Saved data:", formData);
        setEditMode(false);
        // Update the student data with the new values
        setStudentData((prev) => ({
            ...prev,
            ...formData,
        }));
    };
    if (loading) {
        return (
            <>
                <SideBar />
                <Box
                    sx={{
                        flexGrow: 1,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        position: "relative",
                        left: "80px",
                        width: "calc(100% - 80px)",
                        padding: "20px",
                        height: "100vh",
                        overflowY: "scroll",
                        backgroundColor: "#F8F9FD",
                    }}
                >
                    <CircularProgress />
                </Box>
            </>
        );
    }

    return (
        <>
            <SideBar />
            <Box
                sx={{
                    flexGrow: 1,
                    position: "relative",
                    left: "80px",
                    width: "calc(100% - 80px)",
                    padding: "20px",
                    height: "100vh",
                    overflowY: "scroll",
                    backgroundColor: "#F8F9FD",
                }}
            >
                <Breadcrumb />
                <Card elevation={3}>
                    <CardContent>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                mb: 3,
                            }}
                        >
                            <Typography variant="h4" component="h1">
                                Student Profile
                            </Typography>
                            {!editMode ? (
                                <Button
                                    variant="outlined"
                                    startIcon={<Edit />}
                                    onClick={() => setEditMode(true)}
                                >
                                    Edit
                                </Button>
                            ) : (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    startIcon={<Save />}
                                    onClick={handleSave}
                                >
                                    Save
                                </Button>
                            )}
                        </Box>

                        <Divider sx={{ my: 2 }} />

                        <Container
                            disableGutters
                            maxWidth={false}
                            sx={{
                                width: "100%",
                            }}
                        >
                            {/* general information container */}
                            <Container
                                disableGutters
                                maxWidth={false}
                                sx={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "between",
                                    alignContent: "center",
                                    gap: 2,
                                    mb: 4,
                                }}
                            >
                                {/* title container */}
                                <Box
                                    sx={{
                                        width: "40%",
                                        padding: 2,
                                    }}
                                >
                                    <Typography variant="h5" fontWeight={500}>
                                        General Information
                                    </Typography>
                                </Box>

                                {/* input and avatar contianer */}
                                <Box
                                    sx={{
                                        width: "100%",
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr 1fr",
                                        // columnGap: 1,
                                        // rowGap: 1,
                                        gap: 2,
                                        placeItems: "center",
                                    }}
                                >
                                    {/* Avatar section */}
                                    <Avatar
                                        alt={studentData.name}
                                        // src={studentData.avatar}
                                        src={
                                            API_BannerURL.slice(0, -1) +
                                            studentData.profilePicture
                                        }
                                        sx={{
                                            width: "200px",
                                            height: "200px",
                                            aspectRatio: "1/1",
                                            gridRowStart: 1,
                                            gridRowEnd: 4,
                                            gridColumnStart: 3,
                                            gridColumnEnd: 4,
                                        }}
                                    />
                                    {/* display inputs */}
                                    <TextField
                                        label="First Name"
                                        value={studentData?.firstName}
                                        fullWidth
                                        margin="normal"
                                        InputProps={{ readOnly: true }}
                                        sx={{
                                            width: "100%",
                                            ...textFieldStyle,
                                        }}
                                    />
                                    <TextField
                                        label="Last Name"
                                        value={studentData?.lastName}
                                        fullWidth
                                        margin="normal"
                                        InputProps={{ readOnly: true }}
                                        sx={{
                                            width: "100%",
                                            ...textFieldStyle,
                                        }}
                                    />
                                    <TextField
                                        label="Username"
                                        value={studentData?.userName}
                                        fullWidth
                                        margin="normal"
                                        InputProps={{ readOnly: true }}
                                        sx={{
                                            width: "100%",
                                            ...textFieldStyle,
                                        }}
                                    />
                                    <TextField
                                        label="Phone Number"
                                        value={studentData?.phoneNumber}
                                        fullWidth
                                        margin="normal"
                                        InputProps={{ readOnly: true }}
                                        sx={{
                                            width: "100%",
                                            ...textFieldStyle,
                                        }}
                                    />
                                    <TextField
                                        label="Email"
                                        value={studentData?.userEmailId}
                                        fullWidth
                                        margin="normal"
                                        InputProps={{ readOnly: true }}
                                        sx={{
                                            width: "100%",
                                            ...textFieldStyle,
                                        }}
                                    />
                                    <TextField
                                        label="Country"
                                        value={studentDetails.country}
                                        fullWidth
                                        margin="normal"
                                        InputProps={{ readOnly: true }}
                                        sx={{
                                            width: "100%",
                                            ...textFieldStyle,
                                        }}
                                    />
                                    <TextField
                                        label="City"
                                        value={studentDetails.city}
                                        fullWidth
                                        margin="normal"
                                        InputProps={{ readOnly: true }}
                                        sx={{
                                            width: "100%",
                                            ...textFieldStyle,
                                        }}
                                    />
                                    <TextField
                                        label="PinCode"
                                        value={studentDetails.pin}
                                        fullWidth
                                        margin="normal"
                                        InputProps={{ readOnly: true }}
                                        sx={{
                                            width: "100%",
                                            ...textFieldStyle,
                                            gridColumnStart: 2,
                                            gridColumnEnd: -1,
                                        }}
                                    />
                                </Box>
                            </Container>

                            {/* student information container */}
                            <Container
                                disableGutters
                                maxWidth={false}
                                sx={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "between",
                                    alignContent: "center",
                                    gap: 2,
                                    mb: 4,
                                }}
                            >
                                {/* title container */}
                                <Box
                                    sx={{
                                        width: "40%",
                                        padding: 2,
                                    }}
                                >
                                    <Typography variant="h5" fontWeight={500}>
                                        Student Information
                                    </Typography>
                                </Box>

                                {/* input and avatar contianer */}
                                <Box
                                    sx={{
                                        width: "100%",
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr 1fr",
                                        // columnGap: 1,
                                        // rowGap: 1,
                                        gap: 2,
                                        placeItems: "center",
                                    }}
                                >
                                    {/* display inputs */}
                                    <TextField
                                        label="User ID"
                                        value={studentData?.userId}
                                        fullWidth
                                        margin="normal"
                                        InputProps={{ readOnly: true }}
                                        sx={{
                                            width: "100%",
                                            ...textFieldStyle,
                                        }}
                                    />
                                    <TextField
                                        label="Class"
                                        value={studentData?.className}
                                        fullWidth
                                        margin="normal"
                                        InputProps={{ readOnly: true }}
                                        sx={{
                                            width: "100%",
                                            ...textFieldStyle,
                                        }}
                                    />
                                    <TextField
                                        label="School Name"
                                        value={studentData?.schoolName}
                                        fullWidth
                                        margin="normal"
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                        sx={{
                                            width: "100%",
                                            ...textFieldStyle,
                                            // gridColumnStart: 1,
                                            // gridColumnEnd: -1,
                                        }}
                                    />
                                </Box>
                            </Container>

                            {/* parent information container */}
                            <Container
                                disableGutters
                                maxWidth={false}
                                sx={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "between",
                                    alignContent: "center",
                                    gap: 2,
                                    mb: 4,
                                }}
                            >
                                {/* title container */}
                                <Box
                                    sx={{
                                        width: "40%",
                                        padding: 2,
                                    }}
                                >
                                    <Typography variant="h5" fontWeight={500}>
                                        Parents Information
                                    </Typography>
                                </Box>

                                {/* input container */}
                                <Box
                                    sx={{
                                        width: "100%",
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr",
                                        columnGap: 1,
                                    }}
                                >
                                    {editMode ? (
                                        <>
                                            <TextField
                                                name="fathersName"
                                                label="Father's Name"
                                                value={formData.fathersName}
                                                onChange={handleInputChange}
                                                fullWidth
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                sx={{ width: "100%" }}
                                            />
                                            <TextField
                                                name="fathersPhone"
                                                label="Father's Phone Number"
                                                value={formData.fathersPhone}
                                                onChange={handleInputChange}
                                                fullWidth
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                sx={{ width: "100%" }}
                                            />
                                            <TextField
                                                name="mothersName"
                                                label="Mother's Name"
                                                value={formData.mothersName}
                                                onChange={handleInputChange}
                                                fullWidth
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                sx={{ width: "100%" }}
                                            />
                                            <TextField
                                                name="mothersPhone"
                                                label="Mother's Phone Number"
                                                value={formData.mothersPhone}
                                                onChange={handleInputChange}
                                                fullWidth
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                sx={{ width: "100%" }}
                                            />
                                        </>
                                    ) : (
                                        <>
                                            <TextField
                                                label="Father's Name"
                                                value={
                                                    studentDetails.fatherName ||
                                                    "Not provided"
                                                }
                                                fullWidth
                                                margin="normal"
                                                InputProps={{ readOnly: true }}
                                                sx={{ width: "100%" }}
                                            />
                                            <TextField
                                                label="Father's Phone Number"
                                                value={
                                                    studentDetails.father_Phone_Number ||
                                                    "Not provided"
                                                }
                                                fullWidth
                                                margin="normal"
                                                InputProps={{ readOnly: true }}
                                                sx={{ width: "100%" }}
                                            />
                                            <TextField
                                                label="Mother's Name"
                                                value={
                                                    studentDetails.motherName ||
                                                    "Not provided"
                                                }
                                                fullWidth
                                                margin="normal"
                                                InputProps={{ readOnly: true }}
                                                sx={{ width: "100%" }}
                                            />
                                            <TextField
                                                label="Mother's Phone Number"
                                                value={
                                                    studentDetails.mother_Phone_Number ||
                                                    "Not provided"
                                                }
                                                fullWidth
                                                margin="normal"
                                                InputProps={{ readOnly: true }}
                                                sx={{ width: "100%" }}
                                            />
                                        </>
                                    )}
                                </Box>
                            </Container>

                            {/* Badge Container */}
                            <BadgesComponent earnedPoints={earnedPoints} />
                        </Container>
                    </CardContent>
                </Card>
            </Box>
        </>
    );
};

// Internal Compnent for Badegs Container
const BadgesComponent = ({ earnedPoints }) => {
    const badgeObj = [
        {
            comp: bronze,
            name: "Bronze Badge",
            points: 0,
        },
        {
            comp: silver,
            name: "Silver Badge",
            points: 750,
        },
        {
            comp: gold,
            name: "Gold Badge",
            points: 1500,
        },
        {
            comp: platinum,
            name: "Platinum Badge",
            points: 2000,
        },
        {
            comp: legendary,
            name: "Legendary Badge",
            points: 2200,
        },
    ];
    return (
        <>
            <Container
                disableGutters
                maxWidth={false}
                sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "between",
                    alignContent: "center",
                    gap: 2,
                }}
            >
                {/* title container */}
                <Box
                    sx={{
                        width: "40%",
                        padding: 2,
                    }}
                >
                    <Typography variant="h5" fontWeight={500}>
                        My Badges
                    </Typography>
                </Box>

                {/* input container */}
                <Box
                    sx={{
                        // border: "2px solid red",
                        width: "100%",
                        display: "grid",
                        gridTemplateColumns: "repeat(5, 1fr)",
                        columnGap: 1,
                    }}
                >
                    {badgeObj.map((badge, idx) => (
                        <Box
                            key={idx}
                            sx={{
                                position: "relative",
                            }}
                        >
                            <Box
                                sx={{
                                    position: "absolute",
                                    top: -15,
                                    right: -10,
                                    rotate: "10deg",
                                    zIndex: 10,
                                    aspectRatio: "1/1",
                                    width: "30px",
                                }}
                            >
                                {/* Background Image Blur */}
                                <img
                                    src={
                                        badge.points <= earnedPoints
                                            ? "/unlock.svg"
                                            : "/lock.svg"
                                    }
                                    style={{
                                        width: "100%",
                                        height: "auto",
                                        filter: "blur(15px) brightness(1.75)",
                                    }}
                                />
                                {/* Front Image */}
                                <img
                                    src={
                                        badge.points <= earnedPoints
                                            ? "/unlock.svg"
                                            : "/lock.svg"
                                    }
                                    style={{
                                        width: "100%",
                                        height: "auto",
                                        position: "absolute",
                                        inset: 0,
                                        filter: "brightness(1.1)",
                                    }}
                                />
                            </Box>
                            <Box
                                key={idx}
                                sx={{
                                    border: "2px solid #E1E1E1",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderRadius: "5px",
                                    paddingBottom: "10px",
                                    filter:
                                        badge.points <= earnedPoints
                                            ? "grayscale(0%)"
                                            : "grayscale(100%) sepia(45%) hue-rotate(-50deg) saturate(300%)",
                                }}
                            >
                                <Box
                                    sx={{
                                        position: "relative",
                                    }}
                                >
                                    {/* Background Image Blur */}
                                    <img
                                        src={badge.comp}
                                        style={{
                                            width: "100%",
                                            height: "auto",
                                            filter: "blur(15px)",
                                        }}
                                    />
                                    {/* Front Image */}
                                    <img
                                        src={badge.comp}
                                        style={{
                                            width: "100%",
                                            height: "auto",
                                            position: "absolute",
                                            inset: 0,
                                        }}
                                    />
                                </Box>
                                <Typography variant="h5">
                                    {badge.name}
                                </Typography>
                            </Box>
                        </Box>
                    ))}
                </Box>
            </Container>
        </>
    );
};

export default StudentProfile;
